var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLeft = function SvgLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.069 2.274v19.452a1 1 0 0 1-1.518.855L3.482 12.856a1 1 0 0 1 0-1.712l16.069-9.725a1 1 0 0 1 1.518.855",
    className: "left_svg__leftarrow"
  })));
};
export { SvgLeft as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+CiAgICA8dGl0bGU+YXJyb3ctYnV0dG9uLWxlZnQtMjwvdGl0bGU+CiAgICA8cGF0aCBjbGFzcz0ibGVmdGFycm93IiBkPSJNMjEuMDY5LDIuMjc0VjIxLjcyNmExLDEsMCwwLDEtMS41MTguODU1TDMuNDgyLDEyLjg1NmExLDEsMCwwLDEsMC0xLjcxMkwxOS41NTEsMS40MTlBMSwxLDAsMCwxLDIxLjA2OSwyLjI3NFoiLz4KPC9zdmc+";